import { Star } from "lucide-react";

export default function RatingStars({ rating = 0, size = 16, showNumber = true, count }) {
  const r = Math.round(rating * 2) / 2;
  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          className={i <= r ? "fill-accent text-accent" : "text-ink/30"}
        />
      ))}
      {showNumber && (
        <span className="ml-1 text-sm font-semibold">
          {rating.toFixed(1)}{count !== undefined && ` (${count})`}
        </span>
      )}
    </div>
  );
}
